import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { ssoLoginActions, ssoLoginSelectors } from '../reducer/sso-login-reducer';
import { parse } from 'query-string';
import { getAndClearMobileLoginSessionData } from '../services/sso-helpers';
import { lionSelectors, LionTranslate } from '@rosetta/react-lion/dist/index';
import { MouseCatcherContainer as MouseCatcher } from '../../app/util/MouseCatcher';
import { LaunchpadButtonNew, Link } from '../../../styles/LaunchpadButton';
import { isValidInterfaceLanguage } from '../../app/services/language-helpers';
import { appActions, appSelectors} from '../../app/reducer/app-reducer';
import EndInteraction from '../../app/components/EndInteraction';
import { LoginContainer } from './LoginContainer'
import { TextInput } from '../../app/util/TextInput';


/*
  WebSsoLogin may be the same as mobileSsoLogin, the only difference is new UI.
  MobileSsoLogin is where anyone who navigated to /mobilessologin goes.
  They could be coming here because the mobile app sent them here,
  or because after that they successfully logged in and were routed
  back to here by routeSsoFlow().

  In the first case they may need to enter their org namespace
  aka sso_id, or it may have been supplied by query params.  This
  page provides for that.

  In the second case they will either be routed to an error page
  or to the launchpad page aka dashboard.
*/


const P = styled.p`
  padding-bottom: 8px;
  margin-top: -5px;
  text-align: center;
`

const Form = styled.form`
  display: flex;
  flex-direction: column;
  & > *:not(:last-child) {
    margin-bottom: 12px;
  }
`

const SubmitButton = styled(LaunchpadButtonNew)`
  padding-left: 25px;
  padding-right: 25px;
  font-size: 18px,
`


//*********************************************
export class WebSsoLogin extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      tempSsoCode: ''
    };
  }

  componentDidMount = () => {
    this.setState({ tempSsoCode: '' });

    // Clear any error messages
    this.props.errorKeyUpdated(null)


    let mobileSSOLoginData = getAndClearMobileLoginSessionData();
    if (mobileSSOLoginData && mobileSSOLoginData.token) {
      // case where sso login succeeded
      this.props.finishMobileSsoLogin(mobileSSOLoginData);
    } else {
      const queryParams = parse(this.props.location.search);
      if (queryParams.sso_code) {
        // case where initiating login and already have an sso code from previous success
        this.props.attemptMobileSsoLogin(queryParams);
      }

      // show the page and let user fill in the namespace/ssocode
      if (isValidInterfaceLanguage(queryParams.ui_language)) {
        this.props.setInterfaceLanguage(queryParams.ui_language);
      }
    }
  };


  isUIDisabled = () => {
    return this.props.ssoLoginAttemptPending;
  };

  isSubmitButtonDisabled = () => {
    return this.isUIDisabled() || this.props.errorKey || this.state.tempSsoCode.length < 2;
  };

  handleInputChanged = (event) => {
    this.props.errorKeyUpdated(null);
    this.setState({ tempSsoCode: event.target.value });
  };

  handleSubmitButtonClick = e => {
    e.preventDefault();
    let queryParams = parse(this.props.location.search);
    queryParams.sso_code = this.state.tempSsoCode;
    this.props.attemptMobileSsoLogin(queryParams);
  };

  resetInput = () => {
    this.setState({ tempSsoCode: '' });
  };

  returnToLogin = () => {
    // this.props.logoutUser();
    console.log('WebSsoLogin:120 location.href');
    window.location.href = '/login';
  };

  render = () => {
    let localErrorKey = this.props.errorKey;
    if (!localErrorKey) {
      localErrorKey = this.props.mobileSsoLoginError;
    }
    const mouseCatcher = this.isUIDisabled() ? <MouseCatcher left={"0"} /> : null;
    let widgets = null;
    if (!this.props.ssoLoginAttemptPending && this.props.lionLoaded) {
      widgets = (
        <Form>
          <P>
            <LionTranslate lionkey="_mobile_sso_explanation" />
          </P>
          {/* <LockIcon hasError={this.props.mobileSsoLoginError.length > 0} /> */}
          <TextInput
            data-qa="SsoCodeInput"
            type="text"
            value={this.state.tempSsoCode}
            autoCapitalize="none"
            autoCorrect="off"
            autoComplete="off"
            spellCheck="false"
            disabled={this.isUIDisabled()}
            onChange={this.handleInputChanged}
            placeholder={this.props.lionTranslateString('placeholder_sso_code')}
            tabindex="0"
          />

          <SubmitButton
            data-qa="SignInButton"
            onClick={this.handleSubmitButtonClick}
            disabled={this.isSubmitButtonDisabled()}
          >
            {this.props.lionTranslateString('login_button_signin')}
          </SubmitButton>
          <Link data-qa="CancelButton" onClick={() => this.returnToLogin()}>
            {this.props.lionTranslateString('forgotpassword_cancel_link')}
          </Link>
        </Form>
      );
      return (
        <LoginContainer
        header={this.props.lionTranslateString('_mobile_sso_title')}
        data-qa="WebSsoLoginDiv"
        errorMessage={localErrorKey? this.props.lionTranslateString(localErrorKey) : null}>
          {mouseCatcher}
          {/* event will be sent after user authenticates */}
          <EndInteraction interaction="application-startup" />
          {widgets}
        </LoginContainer>
      );
    } else {
      return null;
    }
  };
}

const mapStateToProps = (state, ownprops) => ({
  lionLoaded: lionSelectors.getLionAppResourcesLoaded(state),
  lionLanguage: lionSelectors.getLionLanguage(state),
  currentLocale: lionSelectors.getLionLanguage(state),
  lionTranslateString: (key, placeholders, values) => {
    return lionSelectors.getLionTranslatedString(state, key, placeholders, values);
  },
  ssoLoginAttemptPending: ssoLoginSelectors.ssoLoginAttemptPending(state),
  mobileSsoLoginError: ssoLoginSelectors.mobileSsoLoginError(state),
  errorKey: appSelectors.errorKey(state),
});

const wrapActions = {
  logEvent: appActions.logEvent,
  logoutUser: appActions.logoutUser,
  setMobileSsoLoginError: ssoLoginActions.setMobileSsoLoginError,
  attemptMobileSsoLogin: ssoLoginActions.attemptMobileSsoLogin,
  finishMobileSsoLogin: ssoLoginActions.finishMobileSsoLogin,
  setInterfaceLanguage: appActions.setInterfaceLanguage,
  errorKeyUpdated: appActions.errorKeyUpdated,
};
export const WebSsoLoginContainer = connect(
  mapStateToProps,
  wrapActions
)(WebSsoLogin);



// WEBPACK FOOTER //
// ./src/modules/login/components/WebSsoLogin.jsx